<template>
    <div>
        <nav class="navbar navbar-expand-md navbar-light bg-light">
            <div class="container">
                <routerLink class="navbar-brand" :to="{name: 'home'}" style="background: none !important;">
                    <img src="../../assets/logo-intern.png" alt="">
                </routerLink>
                <button class="navbar-toggler" ref="header_toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarNav">
                    <ul class="navbar-nav ml-auto p-3">
                        <li class="nav-item ml-3" v-if="user != null">
                            Hallo {{user.title}} {{user.forename}} {{user.surname}} <br>
                            Kunden-Nummer: {{user.id}}
                        </li>
                        <li class="nav-item ml-3">
                            <div class="position-relative d-inline-block">
                                <router-link :to="{name: 'anfragen-einsehen', params: {page: 1}}" class="msg" id="anfragen_link" @click.native="collapseHeader">
                                    <font-awesome-icon icon="envelope" v-if="$route.name != 'anfragen-einsehen'" />
                                    <font-awesome-icon icon="envelope-open" v-else />
                                    <b-badge variant="dark" v-if="new_notification > 0" class="notification rounded-circle">{{new_notification}}</b-badge>
                                </router-link>
                                <b-tooltip target="anfragen_link" title="Anfragen"></b-tooltip>
                            </div>
                            <div class="position-relative d-inline-block ml-2">
                                <router-link :to="{name: 'bewertung-einsehen', params: {page: 1}}" class="msg" id="bewertung_link" @click.native="collapseHeader">
                                    <font-awesome-icon icon="star"/>
                                    <b-badge variant="dark" v-if="new_assessment_notification > 0" class="notification rounded-circle">{{new_assessment_notification}}</b-badge>
                                    <b-tooltip target="bewertung_link" title="Bewertungen"></b-tooltip>
                                </router-link>
                            </div>
                            <a class="msg ml-3">
                                <font-awesome-icon icon="sign-out-alt" class="logout" @click="logout" id="logout"/>
                                <b-tooltip target="logout" title="Ausloggen"></b-tooltip>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <div class="drop-btn" @click="toggleMenu" v-if="isMobile">
            Menü
            <font-awesome-icon icon="chevron-circle-down" v-if="toggle_icon"/>
            <font-awesome-icon icon="chevron-circle-up" v-else/>
        </div>
    </div>
</template>

<script>
    import { IsMobileMixin } from '../../mixins/IsMobile';
    import EventBus          from '../../EventBus';

    export default {
        data() {
            return {
                user: undefined,
                new_notification: this.$store.state.notifications_count,
                new_assessment_notification: this.$store.state.assessment_count,
                toggle_icon: true
            }
        },
        mixins: [IsMobileMixin],
        mounted() {
            this.$store.watch( () => {
                    return this.$store.getters.user;
                }, (user) =>{
                    this.user = user
                }
            );
        },
        methods: {
            logout() {
                this.$bvModal.msgBoxConfirm('Möchten Sie sich ausloggen?', {
                    cancelTitle: 'Abbrechen',
                    cancelVariant: 'success',
                    okTitle: 'Ausloggen',
                    okVariant: 'danger',
                    centered: true
                }).then(val => {
                    if(val){
                        this.$store.dispatch('LOGOUT');
                    }
                })
            },
            toggleMenu() {
                this.toggle_icon = !this.toggle_icon;
                EventBus.$emit('TOGGLE_MENU');
            },
            collapseHeader() {
                if(this.isMobile){
                    EventBus.$emit('TOGGLE_MENU', 'hide');
                    this.$refs.header_toggler.click();
                }
            }
        },
        created() {
            this.$store.watch(() => this.$store.getters.notifications_count, count => {
                this.new_notification = count;
            });

            this.$store.watch(() => this.$store.getters.assessment_count, count => {
                this.new_assessment_notification = count;
            });
        }
    }
</script>

<style scoped>
.navbar-brand img{
    height: 50px;
}
.msg{
    font-size: 2rem;
    border: 0;
    box-shadow: none;
    color: #5FA963;
}
.logout{
    color: rgb(175, 175, 175);
    cursor: pointer;
}
.logout:hover{
    color: #5FA963;
}
.notification{
    font-size: 12px;
    position: absolute;
    bottom: 3px;
    left: 0;
}
.drop-btn{
    padding: 10px 0;
    text-align: center;
    color: white;
    width: 100%;
    background: #5FA963;
    font-weight: 800;
}
</style>
